import React, { useEffect } from 'react';
import { useCombobox } from 'downshift';
import classNames from 'classnames';
import { Icon } from 'js/components';

function filterList(inputValue) {
  return (i) => {
    const lowerInputValue = inputValue.toLowerCase().trim();

    return (
      i.display_name?.toLowerCase().includes(lowerInputValue) ||
      i.username?.toLowerCase().includes(lowerInputValue)
    );
  };
}

export default function Combobox({
  placeholder,
  onChange = () => {},
  onItemClick = () => {},
  onEnterKey = () => {},
  onInputBlur = () => {},
  value,
  list,
  itemToKey = (item) => item,
  itemToString = (item) => (item.length ? item : ''),
  itemComponent: ItemComponent = null,
}) {
  const [items, setItems] = React.useState(list);

  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    getInputProps,
    highlightedIndex,
    getItemProps,
    selectedItem,
    inputValue: currentInputValue,
  } = useCombobox({
    onInputValueChange({ inputValue }) {
      // setItems(list.filter(filterList(inputValue)));
      onChange(inputValue);
    },
    items,
    itemToKey,
    itemToString,
    inputValue: value ?? '',
    onStateChange(changes) {
      const { type } = changes;
      if (type === useCombobox.stateChangeTypes.InputKeyDownEnter) {
        onEnterKey();
      } else if (type === useCombobox.stateChangeTypes.InputBlur) {
        onInputBlur();
      } else if (type === useCombobox.stateChangeTypes.ItemClick) {
        onItemClick(changes.selectedItem);
      }
    },
  });

  useEffect(() => {
    setItems(list.filter(filterList(currentInputValue)));
  }, [list, currentInputValue]);

  return (
    <div className="combobox">
      <div className="input-group">
        <input
          placeholder={placeholder}
          className="form-control"
          {...getInputProps()}
        />
        <div className="input-group-append">
          <span
            aria-label="toggle menu"
            className=""
            type="button"
            {...getToggleButtonProps()}
          >
            {isOpen ? (
              <Icon icon={['far', 'chevron-up']} fixedWidth />
            ) : (
              <Icon icon={['far', 'chevron-down']} fixedWidth />
            )}
          </span>
        </div>
      </div>
      <ul
        {...getMenuProps()}
        className="combobox-items"
        style={!isOpen ? { display: 'none' } : {}}
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              className={classNames({
                highlighted: highlightedIndex === index,
                selected: selectedItem === item,
                'combobox-item': true,
              })}
              key={`${item.value}${index}`}
              {...getItemProps({ item, index })}
            >
              {ItemComponent == null ? (
                <span>{item}</span>
              ) : (
                <ItemComponent item={item} />
              )}
            </li>
          ))}
      </ul>
    </div>
  );
}
